import { render, staticRenderFns } from "./SelectedLivingDonorProfileLinks.vue?vue&type=template&id=10bbe814"
import script from "./SelectedLivingDonorProfileLinks.vue?vue&type=script&lang=ts"
export * from "./SelectedLivingDonorProfileLinks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "../_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2Fside-nav%2FSelectedLivingDonorProfileLinks.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@/components/livingDonors/_locales/SideNav.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FlivingDonors%2Fside-nav%2FSelectedLivingDonorProfileLinks.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports